import axios from "axios";
import React, { Dispatch, SetStateAction, useState } from "react";
import { addBlog, editBlog } from "../../../utils/apis/func";
import { useNavigate } from "react-router-dom";

interface Errors {
  blogTitle?: string;
  blogThumbnail?: string;
}

type Props = {
  setShowPublish: Dispatch<SetStateAction<boolean>>;
  content: string;
  isPublish: boolean;
  origBlogTitle?: string;
  origBlogThumbnail?: string;
  blogId: string;
};
const PublishModal: React.FC<Props> = ({
  setShowPublish,
  content,
  isPublish,
  origBlogTitle,
  origBlogThumbnail,
  blogId,
}) => {
  const [blogTitle, setBlogTitle] = useState<string>(
    isPublish ? "" : origBlogTitle ?? ""
  );
  const [blogThumbnail, setBlogThumbnail] = useState<File | null>(null);
  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const hanldleImageUpload = async (image: File) => {
    const formData = new FormData();
    formData.append("profile-picture", image);
    formData.append("folder", "blog");
    try {
      const response = await axios.post(
        "https://api.pureworker.com/api/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.error("Error uploading file", error);
    }
  };
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const newErrors: Errors = {};
    if (!blogTitle.trim()) {
      newErrors.blogTitle = "Please enter a blog title";
    }
    if (!blogThumbnail && isPublish) {
      newErrors.blogThumbnail = "Please select a thumbnail";
    }

    if (Object.keys(newErrors).length === 0) {
      setIsLoading(true);
      let thumbnail;
      if (blogThumbnail) thumbnail = await hanldleImageUpload(blogThumbnail);

      if (isPublish) {
        if (thumbnail) {
          const response = await addBlog({
            title: blogTitle,
            content,
            thumbnail: thumbnail.url,
          });

          if (response.status === 201 || response.status === 200) {
            navigate("/blog");
          } else {
            alert("Something went wrong");
          }
        } else {
          alert("Failed to upload image");
        }
      } else {
        const reqBody = {
          title: blogTitle,
          content,
          thumbnail: thumbnail ? thumbnail : origBlogThumbnail,
        };

        console.log(blogId);
        const response = await editBlog(blogId, reqBody);

        if (response.status === 201 || response.status === 200) {
          navigate("/blog");
        } else {
          console.log(response);
          alert("Something went wrong");
        }
      }
      setIsLoading(false);
    } else {
      setErrors(newErrors);
    }
  };

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBlogTitle(event.target.value);
  };

  const handleThumbnailChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      setBlogThumbnail(event.target.files[0]);
    }
  };

  const displayString = isPublish ? "Publish" : "Update";
  const displayLoadingString = isPublish ? "Publishing..." : "Updating...";
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
      <div className="bg-white p-6 rounded-md">
        <h2 className="text-lg font-medium mb-4">{displayString} Blog</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="blogTitle"
              className="block text-sm font-medium text-gray-700"
            >
              Blog Title:
            </label>
            <input
              type="text"
              id="blogTitle"
              value={blogTitle}
              onChange={handleTitleChange}
              className={`w-full rounded-md border ${
                errors.blogTitle ? "border-red-500" : "border-gray-300"
              } px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#88087B] focus:border-[#88087B]`}
            />
            {errors.blogTitle && (
              <p className="text-sm text-red-500">{errors.blogTitle}</p>
            )}
          </div>
          <div>
            <label
              htmlFor="blogThumbnail"
              className="block text-sm font-medium text-gray-700"
            >
              Blog Thumbnail URL:
            </label>
            <input
              type="file"
              id="blogThumbnail"
              onChange={handleThumbnailChange}
              className={`w-full rounded-md border ${
                errors.blogThumbnail ? "border-red-500" : "border-gray-300"
              } px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#88087B] focus:border-[#88087B]`}
            />
            {errors.blogThumbnail && (
              <p className="text-sm text-red-500">{errors.blogThumbnail}</p>
            )}
          </div>
          <div className="flex justify-end gap-2">
            <button
              className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
              onClick={() => setShowPublish(false)}
              disabled={isLoading}
            >
              cancel
            </button>
            <button
              type="submit"
              className="bg-[#88087B] text-white px-4 py-2 rounded-md hover:bg-[#88087B]"
              disabled={isLoading}
            >
              {isLoading ? displayLoadingString : displayString}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PublishModal;
